import React from 'react';

const PrivacyPolicy = ({ setCurrentPage }) => {
  return (
    <div className="container" style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
      <h2>개인정보처리방침 (초안)</h2>

      <h4>제1조 (개인정보의 처리 목적)</h4>
      <p>LOTTO & TAROT(이하 '서비스')은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
      <p>1. <strong>현재 시점:</strong> 회원가입 기능이 없으므로, 서비스는 사용자의 어떠한 개인정보도 수집하거나 저장하지 않습니다.</p>
      <p>2. <strong>향후 회원제 도입 시:</strong> 회원 식별, 회원 자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 등을 목적으로 개인정보를 처리합니다.</p>

      <h4>제2조 (처리하는 개인정보의 항목)</h4>
      <p>① <strong>(현재)</strong> 서비스는 현재 어떠한 개인정보 항목도 수집하지 않습니다.</p>
      <p>② <strong>(향후 회원제 도입 시)</strong> 다음의 개인정보 항목을 수집할 수 있습니다.<br/>- 필수항목: 이메일 주소, 비밀번호, 닉네임</p>

      <h4>제3조 (개인정보의 처리 및 보유 기간)</h4>
      <p>서비스는 원칙적으로 개인정보를 수집하지 않으므로 해당 사항이 없습니다. 향후 회원제 도입 시, 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다. (예: 회원 탈퇴 시까지)</p>

      <h4>제4조 (개인정보의 제3자 제공)</h4>
      <p>서비스는 정보주체의 개인정보를 원칙적으로 외부에 제공하지 않습니다.</p>

      <h4>제5조 (정보주체의 권리·의무 및 행사방법)</h4>
      <p>정보주체는 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. 이는 향후 회원제 도입 시, 서비스 내 '내 정보' 기능 등을 통해 제공될 예정입니다.</p>

      <h4>제6조 (개인정보의 파기)</h4>
      <p>서비스는 원칙적으로 개인정보를 수집하지 않으므로 해당 사항이 없습니다.</p>

      <h4>제7조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h4>
      <p>서비스는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용할 수 있습니다. 또한, 서비스 이용 과정에서 접속 로그, 서비스 이용 기록 등이 비식별 정보 형태로 자동 생성되어 수집될 수 있습니다. 이는 서비스 품질 개선 및 통계 분석을 위해 사용됩니다.</p>

      <h4>제8조 (개인정보 보호책임자)</h4>
      <p>- 성명: [대표자 또는 책임자 이름]</p>
      <p>- 연락처: [이메일 주소 또는 연락처]</p>

      <h4>제9조 (개인정보 처리방침의 변경)</h4>
      <p>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
      <br/>
      <p>- 공고일자: 2025년 10월 16일</p>
      <p>- 시행일자: 2025년 10월 16일</p>

      <button onClick={() => setCurrentPage('main')} className="action-button" style={{ marginTop: '2rem' }}>메인으로 돌아가기</button>
    </div>
  );
};

export default PrivacyPolicy;
